module.exports = __webpack_public_path__ + "img/btn_download.3f301ff8.svg";